var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import MeetingLoadParticipants from '@web/components/Apps/Meet/MeetingLoadParticipants';
import MeetingsBackToBack from '@web/components/Apps/Meet/MeetingsBackToBack';
import MeetingsByLength from '@web/components/Apps/Meet/MeetingsByLength';
import MeetingsBySchedule from '@web/components/Apps/Meet/MeetingsBySchedule';
import MeetingsBySizeFormat from '@web/components/Apps/Meet/MeetingsBySizeFormat';
import MeetingsByWhen from '@web/components/Apps/Meet/MeetingsByWhen';
import MeetingsByWhoAttended from '@web/components/Apps/Meet/MeetingsByWhoAttended';
import MeetingsPlannedVsActual from '@web/components/Apps/Meet/MeetingsPlannedVsActual';
import MeetingsStats from '@web/components/Apps/Meet/MeetingsStats';
import MeetSummary from '@web/components/Apps/Meet/MeetSummary';
import StickyFilters from '@web/components/Filters/StickyFilters';
export function MeetTab() {
    return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, {}), _jsxs("div", __assign({ className: "flex flex-col mx-1 gap-20 mt-5" }, { children: [_jsx(MeetSummary, {}), _jsx(MeetingLoadParticipants, {}), _jsx(MeetingsBySizeFormat, {}), _jsx(MeetingsByLength, {}), _jsx(MeetingsBySchedule, {}), _jsx(MeetingsByWhoAttended, {}), _jsx(MeetingsByWhen, {}), _jsx(MeetingsPlannedVsActual, {}), _jsx(MeetingsBackToBack, {}), _jsx(MeetingsStats, {})] }))] }));
}
